// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"191":"composer","429":"analyze"}[chunkId] + "." + {"191":"f5c35eaaea1796d27712","429":"58e754217de98afd496e"}[chunkId] + ".js";
};